export default [
  {
    key: 'name',
    label: 'field.name',
    type: 'text',
  },
  {
    key: 'email',
    label: 'field.email',
    type: 'text',
  },
  {
    key: 'serviceCategory',
    label: 'breadcrumb.serviceCategory',
    type: 'async-single-selection',
    repository: 'serviceCategory',
    selectionKey: 'code',
    selectionLabel: 'translations',
    clearable: true,
  },
  {
    key: 'serviceType',
    label: 'breadcrumb.serviceType',
    type: 'async-single-selection',
    repository: 'serviceType',
    selectionKey: 'code',
    selectionLabel: 'translations',
    dependency: 'serviceCategory',
    dependencyKey: 'serviceCategoryCode',
    alwaysFresh: true,
    clearable: true,
  },
  {
    key: 'roleId',
    label: 'field.role',
    type: 'async-single-selection',
    repository: 'role',
    selectionKey: 'id',
    selectionLabel: 'translations',
    alwaysFresh: true,
    clearable: true,
  },
  {
    key: 'isActive',
    label: 'field.status',
    type: 'radio',
    options: [
      { text: 'status.invited', value: '2' },
      { text: 'status.active', value: '1' },
      { text: 'status.inactive', value: '0' },
    ],
    md: 'auto',
    lg: 'auto',
  },
]
